<template>
    <div>
        <h6 class="">{{ $t(`${configId}.featureable.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-4">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-featureable"
                    name="featureable"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    :data-vv-scope="vScope"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('featureable', vScope) }]"
                    :error=" fnFirstError('featureable', vScope)"
                    :helpText="helpFeatureable.status">
                    {{ $t(`${configId}.featureable.model.status`) }}
                </MaterialSelect>
            </div>
        </div>
    </div>
</template>

<script>
import ManagePrintElementMixin from '../mixins/ManagePrintElementMixin';

export default {
    name: 'ConfigFeatureableGeneral',
    mixins: [
        ManagePrintElementMixin
    ],
    props: {
        featureableHelp: {
            type: Object,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        helpFeatureable() {
            return this.featureableHelp ?? this.$t(`${this.configId}.featureable.help`);
        },
    },
}
</script>